export enum pageType {
  PAGE = 'page',
  PRODUCTS_LIST = 'category-list',
  SINGLE_PRODUCT = 'single-product',
  SUBSCRIPTION_PAGE = 'subscription-signup',
  CHECKOUT_PAGE = 'checkout',
  HOME_PAGE = 'home-page',
  SEARCH_PAGE = 'search-page',
  RELATED_PRODUCTS = 'related products'
}